import React, { useEffect, useRef, useState } from "react";
import ModalSkeleton from "../ModalSkeleton";
import Dropzone, { useDropzone } from "react-dropzone";
import classes from "./EditVideoModal.module.css";
import { ImCross } from "react-icons/im";
import { empty_video_thumbnail } from "../../constant/imagePath";
import { Button } from "../../Component/Button/Button";
import PropTypes from "prop-types";
import CircularProgress from "@mui/material/CircularProgress";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { toast } from "react-toastify";
import VideoTumbnail from "../../Component/VideoTumbnail";
import {
  base64ToImage,
  capture,
  convertPNGtoJPEG,
  onClickHandler,
} from "../../config/apiUrl";
import SelectGallery from "../SelectGallery";
import ImageCropPickerModal from "../ImageCropPickerModal/ImageCropPickerModal";

const EditVideoModal = ({
  show,
  setShow,
  handleEdit,
  selectedItem,
  setVideFile,
  videFile,
  videoProgress,
  isLoadingEdit,
  setThumbnailPicture,
  thumbnailPicture,
  noGallery = true,
}) => {
  const [progress, setProgress] = React.useState(10);
  const ref = useRef();
  const [step, setStep] = useState(1);
  const [isFile, setIsFile] = useState(null);
  //gallery State
  const [galleryId, setGalleryId] = useState(null);
  const [showModal, setShowModal] = useState("");
  const [fromGallery, setFromGallery] = useState(false);
  const [isImageCropPickerModalOpen, setIsImageCropPickerModalOpen] =
    useState(false);
  function CircularProgressWithLabel(props) {
    return (
      <Box sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress variant="determinate" {...props} />
        <Box
          sx={{
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography variant="caption" component="div" color="text.secondary">
            {`${Math.round(videoProgress)}%`}
          </Typography>
        </Box>
      </Box>
    );
  }

  console.log(
    thumbnailPicture,
    "thumbnailPicture thumbnailPicture thumbnailPicture"
  );
  const validateFileType = (file) => {
    const acceptedTypes = [
      "video/mp4",
      ".mkv",
      ".avi", // .video file extention list
    ];
    const fileType = file.type;

    if (acceptedTypes.includes(fileType)) {
      return false;
    } else {
      return toast.warn("Please Add Video");
    }
  };
  useEffect(() => {
    return () => {
      setVideFile(null);
    };
  }, []);

  return (
    <>
      <ModalSkeleton
        setShow={setShow}
        show={show}
        width={"1162px"}
        borderRadius={"20px"}
      >
        <div>
          <h3>Update Video</h3>
        </div>
        {!isFile && step == 1 ? (
          <>
            <Dropzone
              validator={validateFileType}
              //   accept=".doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              //   accept=".docx"
              //   accept={{ "application/msword": [] }}
              //   noClick={true}
              //   disabled={true}
              onDrop={(acceptedFiles) => {
                setIsFile(URL.createObjectURL(acceptedFiles[0]));
                setVideFile(acceptedFiles[0]);
                setFromGallery(true);
              }}
            >
              {({ getRootProps, getInputProps }) => (
                <section className={classes.uploadBox}>
                  <div
                    className={classes.input_box}
                    style={{
                      display: isFile && "flex",
                      alignItems: isFile && "center",
                    }}
                    {...getRootProps()}
                  >
                    <input {...getInputProps()} />
                    {isFile?.length > 0 ? (
                      <div className={classes.div_main}>
                        <div
                          className={classes.cross_icon}
                          onClick={() => setIsFile([])}
                        >
                          <ImCross />
                        </div>
                        {/* <img src={word_file_icon} /> */}
                      </div>
                    ) : (
                      <div className={classes.empty_video_div}>
                        <div className={classes.img_div_thumbail}>
                          <img src={empty_video_thumbnail} />
                        </div>
                        <h4>Drag & Drop</h4>
                        <h4>
                          Or <span>Browse</span>
                        </h4>
                      </div>
                    )}
                  </div>
                </section>
              )}
            </Dropzone>
          </>
        ) : (
          step == 1 && (
            <>
              <div className={classes.video_tag}>
                {/* {isFile && (
              <ReactPlayer
              
                // width={300}
                // height={300}
                url={isFile}
                style={{
                  width: "178px !important",
                  height: "160px !important",
                }}
              />
            )} */}
                <video
                  autoplay
                  src={isFile}
                  width="750"
                  height="500"
                  controls
                ></video>
              </div>
            </>
          )
        )}
        {step == 2 && (
          <VideoTumbnail
            video={videFile}
            setThumbnailPicture={setThumbnailPicture}
            thumbnailPicture={thumbnailPicture}
          />
        )}

        <div className="text-center mt-4 mb-4">
          {videoProgress > 0 && <CircularProgressWithLabel value={progress} />}
        </div>
        {step == 1 && (
          <div className={"text-center mt-5"}>
            {noGallery && (
              <Button
                customStyle={{ marginRight: "20px" }}
                onClick={() => setShowModal("Gallery")}
                label={"Select From Gallery"}
              />
            )}
            <Button
              label={"Next"}
              onClick={() => {
                isFile
                  ? setStep((prev) => prev + 1)
                  : toast.warn("Please Add Video");
              }}
            />
          </div>
        )}
        {step == 2 && (
          <div className={"text-center mt-5"}>
            <Button
              customStyle={{
                marginRight: "20px",
              }}
              onClick={() => ref.current.click()}
              label={"+"}
            />

            <Button
              customStyle={{
                marginRight: "20px",
              }}
              label={"Capture"}
              onClick={() => capture(setThumbnailPicture)}
            />
            {/* {!noGallery && (
              <Button
                customStyle={{
                  marginRight: "20px",
                }}
                label={"Take Screen shot"}
                onClick={() => setIsImageCropPickerModalOpen(true)}
              />
            )} */}

            <Button
              customStyle={{
                marginRight: "20px",
              }}
              disabled={isLoadingEdit}
              label={isLoadingEdit ? "Please Wait..." : "Submit"}
              onClick={async () => {
                let JpgThumb = null;

                try {
                  JpgThumb = await convertPNGtoJPEG(thumbnailPicture);
                } catch (error) {
                  console.log(error, "error");
                }

                handleEdit({
                  gallery: fromGallery ? selectedItem?._id : galleryId,
                  // description: videFile,
                  thumbnail: thumbnailPicture,
                  isVideo: fromGallery,
                });
              }}
            />

            <>
              <div className={classes.btn_div_gallery}>
                <input
                  accept="image/jpeg"
                  ref={ref}
                  style={{ visibility: "none" }}
                  type="file"
                  onChange={(event) => {
                    console.log(event, "event event event");
                    // onClickHandler(event, setThumbnailPicture);
                    //code commented when sending image to backend its goind base64

                    // const file = event.target.files[0];
                    // if (file) {
                    //   const reader = new FileReader();
                    //   reader.onload = (e) => {
                    //     setThumbnailPicture(e.target.result);
                    //   };
                    //   reader.readAsDataURL(file);
                    // }
                    //xxxxxxxxxxxxx//
                    setThumbnailPicture(event.target.files[0]);
                    // For Clear Image in Canvas ---

                    var canvas = document.getElementById("canvas");

                    const context = canvas.getContext("2d");
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    // For Clear Image in Canvas ---

                    var ctx = document
                      .getElementById("canvas")
                      .getContext("2d");
                    var img = new Image();
                    img.onload = function () {
                      ctx.drawImage(img, 0, 0, 250, 400);
                    };
                    img.src = URL.createObjectURL(event.target.files[0]);
                  }}
                />
              </div>
            </>
          </div>
        )}
        {isImageCropPickerModalOpen && thumbnailPicture && (
          <ImageCropPickerModal
            show={isImageCropPickerModalOpen}
            setShow={setIsImageCropPickerModalOpen}
            picture={thumbnailPicture}
            onSubmit={(picture) => {
              setThumbnailPicture(picture);
              console.log(picture, "picture picture picture");

              // setStep((prev) => prev + 1);
              setIsImageCropPickerModalOpen(false);
              setFromGallery(false);
            }}
          />
        )}

        {showModal == "Gallery" && (
          <SelectGallery
            setGalleryId={setGalleryId}
            setIsFile={setIsFile}
            setShow={setShowModal}
            show={showModal == "Gallery"}
            setVideFile={setVideFile}
            galleryId={galleryId}
            setFromGallery={setFromGallery}
          />
        )}
      </ModalSkeleton>
    </>
  );
};

export default EditVideoModal;
